import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PagerType } from "./types";
import { ProductDetailDTO, ProductListResponseDTO, SearchProductListResponseDTO } from "@app/api/generated-api";
import { initialized, RemoteData, RemoteDataStatus } from "../../../libs/remote";
import {HYDRATE} from "next-redux-wrapper";

export interface IMyGoodsState {
  products: RemoteData<ProductListResponseDTO>;
  detailProduct: RemoteData<ProductDetailDTO>;
  pager: PagerType;
  searchProduct: RemoteData<SearchProductListResponseDTO>;
  postProductStatus: {status: RemoteDataStatus, error?: any };
  postPleadStatus: {status: RemoteDataStatus, error?: any };
}

const initialState: IMyGoodsState = {
  products: initialized() as RemoteData<ProductListResponseDTO>,
  detailProduct: initialized() as RemoteData<ProductDetailDTO>,
  pager: { page_size: null, page_number: null, showMore: false },
  searchProduct: initialized() as RemoteData<SearchProductListResponseDTO>,
  postProductStatus: {status: RemoteDataStatus.Initialized},
  postPleadStatus: {status: RemoteDataStatus.Initialized},
};

export const myGoodsSlice = createSlice({
  name: "myGoods",
  initialState,
  reducers: {
    fetchProducts: (_state, _payload: PayloadAction<PagerType>) => {},
    setProducts: (state, action: PayloadAction<RemoteData<ProductListResponseDTO>>) => {
      state.products = action.payload;
    },

    fetchDetailProduct: (_state, _payload: PayloadAction<{ id: string }>) => {},
    setDetailProduct: (state, action: PayloadAction<RemoteData<ProductDetailDTO>>) => {
      state.detailProduct = action.payload;
    },

    fetchSearchProducts: (_state, _payload: PayloadAction<{ q: string }>) => {},
    setSearchProduct: (state, action: PayloadAction<RemoteData<SearchProductListResponseDTO>>) => {
      state.searchProduct = action.payload;
    },

    postProduct: (_state, _payload: PayloadAction<{ data: FormData }>) => {},
    setPostProductStatus: (state, action: PayloadAction<{status: RemoteDataStatus, error?: any}>) => {
      state.postProductStatus = action.payload;
    },

    setPager: (state, action: PayloadAction<PagerType>) => {
      state.pager = action.payload;
    },
    postPleadData: (_state, _payload: PayloadAction<{ data: FormData }>) => {},
    setPostPleadStatus: (state, action: PayloadAction<{status: RemoteDataStatus, error?: any}>) => {
      state.postPleadStatus = action.payload;
    },
  },

  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...action.payload.products
      }
    }
  }
});

export const {
  fetchProducts,
  setProducts,
  setPager,
  fetchDetailProduct,
  setDetailProduct,
  fetchSearchProducts,
  setSearchProduct,
  postProduct,
  setPostProductStatus,
  postPleadData,
  setPostPleadStatus,
} = myGoodsSlice.actions;
export default myGoodsSlice.reducer;
